



























import { Vue, Component, Prop } from "vue-property-decorator";
import OrganizationModel from "@/model/Organization";

@Component({})
export default class SummaryOrganizations extends Vue {
  @Prop()
  readonly value!: OrganizationModel[];
}

//
